import { render, staticRenderFns } from "./comp_CheckoutStep-confirm.vue?vue&type=template&id=0c2afec0&scoped=true&"
import script from "./comp_CheckoutStep-confirm.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-confirm.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-confirm.vue?vue&type=style&index=0&id=0c2afec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2afec0",
  null
  
)

export default component.exports